
import Vue, { PropType } from "vue";
import { Company } from "@/models";

import CompanyListItem from "./CompanyListItem.vue";

export default Vue.extend({
  name: "CompanyList",

  props: {
    companies: Array as PropType<Array<Company>>,
  },

  components: {
    CompanyListItem,
  },
});
